/**
 * Mobile Sticky Call Button Field Definitions
 *
 * Primary props:
 * - phone (auto-populated from business context)
 * - buttonText
 *
 * Advanced props:
 * - scrollThreshold
 * - dismissible
 */

export const MobileStickyCallFields = {
  phone: {
    type: "text",
    label: "Phone Number",
    metadata: {
      source: "context",
      contextKey: "business.phone",
      description: "Phone number for tap-to-call (auto-populated from business)",
    },
  },
  buttonText: {
    type: "text",
    label: "Button Text",
    metadata: {
      source: "manual",
      description: "Text displayed on the call button",
    },
  },
  showTextUs: {
    type: "radio",
    label: "Show Text Us Button",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
      description: "Show or hide the Text Us button on the mobile sticky bar",
    },
  },
  scrollThreshold: {
    type: "number",
    label: "Advanced: Scroll Threshold (px)",
    metadata: {
      source: "manual",
      description: "Pixels to scroll before button appears",
      advanced: true,
    },
  },
  dismissible: {
    type: "radio",
    label: "Advanced: Allow Dismiss",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
      description: "Allow users to dismiss the button for the session",
      advanced: true,
    },
  },
} as const;
